import { Controller } from '@hotwired/stimulus'

// Mobile menu: a real <button> drives daisyUI's drawer checkbox and keeps aria-expanded in sync; Esc closes.
export default class DrawerController extends Controller<HTMLElement> {
  static override targets = ['checkbox', 'button']
  declare readonly checkboxTarget: HTMLInputElement
  declare readonly buttonTarget: HTMLButtonElement

  toggle(): void {
    this.checkboxTarget.checked = !this.checkboxTarget.checked
    this.sync()
  }

  // An open modal (command palette, confirm) owns Esc: it closes itself and returns focus into the still-open drawer.
  close(): void {
    if (!this.checkboxTarget.checked || document.querySelector('dialog:modal, :popover-open')) return
    this.checkboxTarget.checked = false
    this.sync()
    this.buttonTarget.focus()
  }

  sync(): void {
    this.buttonTarget.setAttribute('aria-expanded', String(this.checkboxTarget.checked))
  }
}
